import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'

import { asyncRouterMap, constantRouterMap } from '@/router/index'
import store from '../index'

@Module({ dynamic: true, store, name: 'permission' })
class Permission extends VuexModule {
  public routers:any[] = []
  public addRouters:any[] = []
  public navRouters:any[] = []

  @Mutation
  private SET_ROUTERS(routers: any[]) {
    this.addRouters = routers
    this.routers = constantRouterMap.concat(routers)
    // console.log('routes', this.routers)
    // console.log('addRouters', this.addRouters)
  }

  @Mutation
  private SET_NAV_ROUTERS(routers: any[]) {
    this.navRouters = routers
  }

  @Action
  public GenerateRoutes(codes: number[]) {
    return new Promise(resolve => {
      let accessedRouters = filterAsyncRouter(asyncRouterMap, codes)
      // console.log(accessedRouters)
      // let newRedirectRouters:any[] = setRedirect(accessedRouters)
      // 重设 跟路由 跳转首页（拥有权限的第一项）
      if (accessedRouters.length > 2) {
        accessedRouters[0].redirect = accessedRouters[1].path
      } else {
        accessedRouters[0].redirect = '/settings'
      }
      accessedRouters = setRedirect(accessedRouters)
      // console.log(accessedRouters)
      // commit('SET_ROUTERS', accessedRouters)
      this.SET_ROUTERS(accessedRouters)
      this.SET_NAV_ROUTERS(accessedRouters)
      resolve()
    })
  }

  @Action
  public SetRouters(routers: any[]) {
    this.SET_ROUTERS(routers)
  }
  @Action
  public SetNavRouters(routers: any[]) {
    this.SET_NAV_ROUTERS(routers)
  }
}

/**
 * 通过meta.code判断是否与当前用户权限匹配
 * @param codes
 * @param route
 */
function hasPermission(route: any, codes: number[]) {
  if (route.meta && route.meta.code) {
    // 需要权限
    return codes.indexOf(route.meta.code) >= 0
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param codes
 */
function filterAsyncRouter(asyncRouterMap: any[], codes: number[]) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (hasPermission(route, codes)) {
      // 有权限
      if (route.children && route.children.length > 0) {
        route.children = filterAsyncRouter(route.children, codes)
      }
      return true
    }
  })
  return accessedRouters
}

/**
 * 递归设置 有子路由的 节点的redirect 为第一个子路
 */
function setRedirect(asyncRouterMap: any[]) {
  let newRouters = asyncRouterMap.map(item => {
    if (item.children && item.children.length > 0) {
      item.redirect = item.redirect
        ? item.redirect
        : (item.rootPath || item.path) + '/' + item.children[0].path
      item.children.map((_item: any, _index: number) => {
        if (_item.path) {
          _item.rootPath = (item.rootPath || item.path) + '/' + _item.path
        } else {
          _item.rootPath = item.rootPath || item.path
        }
      })
      setRedirect(item.children)
    }
    return item
  })
  return newRouters
}

export const PermissionModule = getModule(Permission)
